<template>

</template>

<script>
import format from 'date-fns/format'
import {db, auth} from '@/fb'

export default {
  data() {
    return {
      admin: false
    }
  },
  computed: {
    
  }
}
</script>
